import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, fetchMe, getFleetPass } from "@/lib/api";

// Access rule (owner 2026-10-29): a new user sees the public landing page
// only; after login, every driver screen steers them to the paywall until a
// subscription is active. Access = an active fleet pass (fleet drivers may
// carry no account at all) OR a personal paid subscription.
export default function RequirePaid({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        let live = true;
        (async () => {
            // 1) fleet pass first — fleet drivers may have no login at all
            const pass = getFleetPass();
            if (pass?.fleet_code) {
                try {
                    const d = await api(`/fleets/${pass.fleet_code}/access`);
                    if (d.paid) {
                        if (live) setAllowed(true);
                        return;
                    }
                } catch {
                    /* fleet check is best-effort; fall through to account */
                }
            }
            // 2) account path
            try {
                await fetchMe();
            } catch {
                if (live) navigate(`/login?next=${encodeURIComponent(location.pathname)}`);
                return;
            }
            let paid = false;
            try {
                const d = await api("/auth/access");
                paid = !!d.paid;
            } catch {}
            if (!live) return;
            if (paid) setAllowed(true);
            else navigate("/paywall");
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!allowed) {
        return (
            <div
                data-testid="paid-gate-loading"
                className="flex min-h-screen items-center justify-center bg-[#161413]"
            >
                <p className="font-display animate-pulse text-3xl tracking-widest text-[#E5A93C]">LOADING…</p>
            </div>
        );
    }
    return children;
}
